import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import ServiceProviderService from '../../services/ServiceProviderService';
import FormInputText from '../_shared/forms/FormInputText';
import FormCheckbox from '../_shared/forms/FormCheckbox';
import FormSelect from '../_shared/forms/FormSelect';
import CreatableSelect from '../_shared/forms/FormCreatableSelect';
import FormInputNumber from '../_shared/forms/FormInputNumber';
import { snakeCaseToTitle } from '../../utils/Helpers';
import SubmitButton from '../_shared/SubmitButton';

class CreateServiceProvider extends Component {
    constructor(props) {
        super(props);

        this.serviceProviderService = new ServiceProviderService();

        const { provider } = this.props;

        const zone = {
            name: '',
            prefixes: [],
            surcharge: 0,
            errors: {},
        };

        let zones =
            provider.coverage_areas && provider.coverage_areas.length > 0 ? [...provider.coverage_areas] : [zone];
        //  Generate unique id for each zone to use in react-select
        zones.map((zone, index) => {
            return (zone.id = index + 1);
        });

        //  Disable preselected postcodes
        let postcodes = this.props.postcodes;
        zones.forEach((zone) => {
            zone.prefixes.forEach((postcode) => {
                let postcodeOption = postcodes.findIndex((postcodeOption) => {
                    return postcodeOption.id === postcode.id;
                });

                if (postcodeOption !== -1) {
                    postcodes[postcodeOption] = { ...postcodes[postcodeOption], disabled: true };
                }
            });
        });

        this.state = {
            name: provider.name || '',
            address_line_1: provider.address_line_1 || '',
            address_line_2: provider.address_line_2 || '',
            postcode: provider.postcode || '',
            city: provider.city || '',
            telephone: provider.telephone || '',
            email: provider.email || '',
            xero_id: provider.xero_id || '',
            password: '',
            active: provider.active === 1,
            covers_sor_jobs: provider.covers_sor_jobs || false,
            invoice_recipient: provider.invoice_recipient || '',
            bank_account_number: provider.bank_account_number || '',
            bank_sort_code: provider.bank_sort_code || '',
            vat_number: provider.vat_number || '',
            waste_carrier_license: provider.waste_carrier_license || '',
            payment_term: provider.payment_term || 30,
            invoice_period: provider.invoice_period || '',
            self_billing: provider.self_billing !== undefined ? provider.self_billing : true,
            sic_code: provider.sic_code || 38110,
            zones: zones,
            postcodes: postcodes,
            errors: {},
            zoneDeleteError: '',
            loading: false,
            showSuccessToast: false,
            showErrorToast: false,
            vat_registered: provider.vat_registered === 1,
            active_invoice: provider.active_invoice === 1,
            review_invoices: provider.review_invoices === 1,
            manager_review_jobs: provider.manager_review_jobs === 1,
            superadmin_review_jobs: provider.superadmin_review_jobs === 1,

        };
        console.log(this.props);
    }

    handleInputChange = (e) => {
        this.resetErrors();

        const { name, value, type } = e.target;
        this.setState({
            [name]: type === 'checkbox' ? !this.state[name] : value,
            errors: {},
        });
    };

    handleZoneInputChange = (e, i) => {
        this.resetErrors();
        const { name, value } = e.target;
        let zones = [...this.state.zones];

        zones[i] = {
            ...zones[i],
            [name]: value,
        };

        this.setState({ zones });
    };

    appendZone = (e) => {
        e.preventDefault();
        this.resetErrors();
        this.setState((prevState) => ({
            zones: [
                ...prevState.zones,
                {
                    //  Generate unique id for this zone by getting id of last zone element in 'prevState' and increment by 1
                    id: prevState.zones[prevState.zones.length - 1].id + 1,
                    name: '',
                    prefixes: [],
                    surcharge: 0,
                    errors: {},
                },
            ],
        }));
    };

    handleMultiSelectChange = (value, i) => {
        let zones = [...this.state.zones];
        zones[i] = {
            ...zones[i],
            prefixes: value || [],
        };

        //disable selected postcode
        let postcodes = [...this.state.postcodes];
        if (typeof zones[i].prefixes[zones[i].prefixes.length - 1] !== 'undefined') {
            let postcodeIndex = postcodes.findIndex((postcode) => {
                return postcode.id === zones[i].prefixes[zones[i].prefixes.length - 1].id;
            });
            if (postcodeIndex !== -1) {
                postcodes[postcodeIndex] = { ...postcodes[postcodeIndex], disabled: true };
            }
        }

        this.setState({
            zones,
            postcodes,
        });
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        this.setState({ loading: true });

        if (await this.validateForm()) {
            this.props.edit
                ? this.serviceProviderService
                      .updateServiceProvider(this.props.provider.id, this.state)
                      .then(
                          (res) => {
                              //  Stop spinner flag
                              this.setState({ loading: false });
                              toastr.success('This service provider was successfully updated.');
                          },
                          (err) => {
                              this.setState({
                                  errors: err.response.data.errors,
                                  loading: false,
                              });
                          }
                      )
                      .catch(() => {
                          //  Stop spinner flag
                          this.setState({ loading: false });
                          toastr.error('There was a problem while submitting the form. Please try again.');
                      })
                : this.serviceProviderService
                      .createServiceProvider(this.state)
                      .then(
                          (res) => {
                              //  Stop spinner flag
                              this.setState({ loading: false });
                              return (window.location.href = res.data.redirect_url);
                          },
                          (err) => {
                              this.setState({
                                  errors: err.response.data.errors,
                                  loading: false,
                              });
                          }
                      )
                      .catch(() => {
                          this.setState({
                              loading: false,
                          });
                          toastr.error('There was a problem while submitting the form. Please try again');
                      });
        }
    };

    validateForm = async () => {
        let valid = true;
        let errors = this.state.errors;
        const fields = [
            'name',
            'address_line_1',
            'postcode',
            'city',
            'telephone',
            'email',
            'covers_sor_jobs',
            'invoice_recipient',
            'bank_account_number',
            'bank_sort_code',
            'vat_number',
            'payment_term',
            'invoice_period',
            'self_billing',
            'vat_registered',
            'active'
            // 'waste_carrier_license'
        ];

        fields.map((field) => {
            errors[field] = this.state[field] === '' ? `${snakeCaseToTitle(field)} field is required` : '';
        });

        if (!(await this.validateZones())) valid = false;

        await this.setState({ errors }, () => {
            Object.values(errors).forEach((val) => val.length > 0 && (valid = false));
        });
        if (!valid) {
            this.setState({ loading: false });
            toastr.error('Please fill in all the required fields');
        }
        return valid;
    };

    validateZones = async () => {
        let valid = true;
        let zones = [...this.state.zones];
        zones.map((zone, index) => {
            if (zone.prefixes.length === 0) {
                zones[index].errors.prefixes = 'Postcodes field is required';
                valid = false;
            }

            if (zone.surcharge === '') {
                zones[index].errors.surcharge = 'Surcharge field is required';
                valid = false;
            }

            if (zone.name === '') {
                zones[index].errors.name = 'Name field is required';
                valid = false;
            }
        });

        await this.setState({ zones });
        return valid;
    };

    removeZone = (e, i) => {
        e.preventDefault();

        if (this.state.zones.length === 1) {
            return this.setState({
                zoneDeleteError: 'You need to add at least one coverage zone',
            });
        }

        window.swal
            .fire({
                title: `Delete this zone?`,
                text: `Are you sure you want to delete this coverage zone?`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Delete',
            })
            .then((isConfirm) => {
                if (isConfirm.dismiss) return;
                this.setState((prevState) => ({
                    zones: prevState.zones.filter((zone) => prevState.zones.indexOf(zone) !== i),
                }));
            });
    };

    resetErrors = () => {
        let zones = [...this.state.zones];
        zones.map((zone) => (zone.errors = {}));

        this.setState({
            errors: {},
            zones: zones,
            zoneDeleteError: '',
        });
    };

    render() {
        let submitButtonText = this.props.edit ? 'Save changes' : 'Create service provider';
        const {
            name,
            address_line_1,
            address_line_2,
            postcode,
            city,
            telephone,
            email,
            xero_id,
            waste_carrier_license,
            sic_code,
            password,
            covers_sor_jobs,
            active,
            errors,
            invoice_recipient,
            bank_account_number,
            bank_sort_code,
            vat_number,
            payment_term,
            invoice_period,
            self_billing,
            zones,
            zoneDeleteError,
            vat_registered,
            active_invoice,
            review_invoices,
            manager_review_jobs,
            superadmin_review_jobs
        } = this.state;
        return (
            <Fragment>
                <form onSubmit={(e) => this.handleSubmit(e)} className="transform-text">
                    {!this.props.coverage && (
                        <Fragment>
                            <div className="row">
                                <div className="col-12">
                                    <h6 className="py-2 pl-2 cw-bg-grey text-white">Service Provider Details</h6>
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-group col-md-4">
                                    <FormInputText
                                        label="Name"
                                        name="name"
                                        type="text"
                                        classes={errors.name ? 'form-control is-invalid' : 'form-control'}
                                        value={name}
                                        handleChange={this.handleInputChange}
                                        error={errors.name}
                                    />
                                </div>
                                <div className="form-group col-md-4">
                                    <FormInputText
                                        label="Address Line 1"
                                        name="address_line_1"
                                        type="text"
                                        classes={errors.address_line_1 ? 'form-control is-invalid' : 'form-control'}
                                        value={address_line_1}
                                        handleChange={this.handleInputChange}
                                        error={errors.address_line_1}
                                    />
                                </div>
                                <div className="form-group col-md-4">
                                    <FormInputText
                                        label="Address Line 2"
                                        name="address_line_2"
                                        type="text"
                                        classes={errors.address_line_2 ? 'form-control is-invalid' : 'form-control'}
                                        value={address_line_2}
                                        handleChange={this.handleInputChange}
                                        error={errors.address_line_2}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-group col-md-4">
                                    <FormInputText
                                        label="Postcode"
                                        name="postcode"
                                        type="text"
                                        classes={errors.postcode ? 'form-control is-invalid' : 'form-control'}
                                        value={postcode}
                                        handleChange={this.handleInputChange}
                                        error={errors.postcode}
                                    />
                                </div>
                                <div className="form-group col-md-4">
                                    <FormInputText
                                        label="City"
                                        name="city"
                                        type="text"
                                        classes={errors.city ? 'form-control is-invalid' : 'form-control'}
                                        value={city}
                                        handleChange={this.handleInputChange}
                                        error={errors.city}
                                    />
                                </div>
                                <div className="form-group col-md-4">
                                    <FormInputText
                                        label="Telephone"
                                        name="telephone"
                                        type="text"
                                        classes={errors.telephone ? 'form-control is-invalid' : 'form-control'}
                                        value={telephone}
                                        handleChange={this.handleInputChange}
                                        error={errors.telephone}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-group col-md-4">
                                    <FormInputText
                                        label="Email"
                                        name="email"
                                        type="email"
                                        classes={
                                            errors.email
                                                ? 'form-control is-invalid text-none'
                                                : 'form-control text-none'
                                        }
                                        value={email}
                                        handleChange={this.handleInputChange}
                                        error={errors.email}
                                        disabled={typeof this.props.provider.id !== 'undefined'}
                                    />
                                </div>
                                <div className="form-group col-md-4">
                                    <FormInputText
                                        label="Xero Id"
                                        name="xero_id"
                                        type="text"
                                        classes={
                                            errors.xero_id
                                                ? 'form-control is-invalid text-none'
                                                : 'form-control text-none'
                                        }
                                        value={xero_id}
                                        handleChange={this.handleInputChange}
                                        error={errors.xero_id}
                                    />
                                </div>
                                <div className="form-group col-md-4">
                                    <FormInputText
                                        label="Waste carrier license number"
                                        name="waste_carrier_license"
                                        type="text"
                                        classes={
                                            errors.waste_carrier_license
                                                ? 'form-control is-invalid text-none'
                                                : 'form-control text-none'
                                        }
                                        value={waste_carrier_license}
                                        handleChange={this.handleInputChange}
                                        error={errors.waste_carrier_license}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-group col-md-4">
                                    <FormInputText
                                        label="SIC Code"
                                        name="sic_code"
                                        type="text"
                                        classes={
                                            errors.sic_code
                                                ? 'form-control is-invalid text-none'
                                                : 'form-control text-none'
                                        }
                                        value={sic_code}
                                        handleChange={this.handleInputChange}
                                        error={errors.sic_code}
                                    />
                                </div>
                                <div className="form-group col-md-4">
                                    <FormInputText
                                        label="Password"
                                        name="password"
                                        type="password"
                                        classes={
                                            errors.password
                                                ? 'form-control is-invalid text-none'
                                                : 'form-control text-none'
                                        }
                                        value={password}
                                        handleChange={this.handleInputChange}
                                        error={errors.password}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                 <div className="form-group col-md-4">
                                    <FormCheckbox
                                        label="Active"
                                        name="active"
                                        checked={active}
                                        handleChange={this.handleInputChange}
                                    />
                                    <FormCheckbox
                                        label="DOES COVER SOR JOBS"
                                        name="covers_sor_jobs"
                                        checked={covers_sor_jobs}
                                        handleChange={this.handleInputChange}
                                    />
                                </div>
                            </div>

                        </Fragment>
                    )}
                    {this.props.userIsAdmin ? (
                        <div>
                            <div className="row">
                                <div className="col-12">
                                    <h6 className="py-2 pl-2 cw-bg-grey text-white">Coverage Zones</h6>
                                </div>
                            </div>
                            {this.state.zones.map((zone, i) => {
                                return (
                                    <Fragment key={zone.id}>
                                        <div className="row">
                                            <div className="form-group col-md-4">
                                                <FormInputText
                                                    label="Zone Name"
                                                    name="name"
                                                    type="text"
                                                    classes={
                                                        zone.errors.name ? 'form-control is-invalid' : 'form-control'
                                                    }
                                                    error={zone.errors.name}
                                                    value={zone.name}
                                                    handleChange={(e) => this.handleZoneInputChange(e, i)}
                                                    disabled={!this.props.canUpdatePricing}
                                                />
                                                {zoneDeleteError && (
                                                    <small className="text-danger">{zoneDeleteError}</small>
                                                )}
                                            </div>
                                            <div className="form-group col-md-4">
                                                <CreatableSelect
                                                    isMulti
                                                    label="covers postcodes"
                                                    options={this.state.postcodes}
                                                    handleMultiSelectChange={(e) => this.handleMultiSelectChange(e, i)}
                                                    error={zone.errors.prefixes}
                                                    classes={
                                                        zone.errors.prefixes
                                                            ? 'form-control is-invalid'
                                                            : 'form-control'
                                                    }
                                                    prefixes={zone.prefixes}
                                                    disabled={!this.props.canUpdatePricing}
                                                />
                                            </div>
                                            <div className="form-group col-md-3">
                                                <label>Surcharge</label>
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span
                                                            className={
                                                                zones[i].errors.surcharge
                                                                    ? 'input-group-text border-danger'
                                                                    : 'input-group-text'
                                                            }
                                                        >
                                                            &#163;
                                                        </span>
                                                    </div>
                                                    <input
                                                        type="number"
                                                        placeholder="Surcharge..."
                                                        className={
                                                            zone.errors.surcharge
                                                                ? 'form-control is-invalid'
                                                                : 'form-control'
                                                        }
                                                        step="0.01"
                                                        min="0"
                                                        value={zone.surcharge}
                                                        name="surcharge"
                                                        onChange={(e) => this.handleZoneInputChange(e, i)}
                                                        disabled={!this.props.canUpdatePricing}
                                                    />
                                                    <div className="invalid-feedback">{zone.errors.surcharge}</div>
                                                </div>
                                            </div>
                                            {this.props.canUpdatePricing && (
                                                <div className="form-group col-md-1 text-center">
                                                    <label>&nbsp;</label>
                                                    <div onClick={(e) => this.removeZone(e, i)}>
                                                        <i className="nc-icon nc-simple-remove icon-bold text-danger pb-3">
                                                            {' '}
                                                        </i>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </Fragment>
                                );
                            })}
                            {this.props.canUpdatePricing && (
                                <div className="row">
                                    <div className="col-12">
                                        <button
                                            type="button"
                                            onClick={this.appendZone}
                                            className="btn btn-outline-cw-primary"
                                        >
                                            <i className="fas fa-plus-square"> </i> Add new zone
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        ''
                    )}
                    {!this.props.coverage && (
                        <Fragment>
                            <div className="row pt-3">
                                <div className="col-12">
                                    <h6 className="py-2 pl-2 cw-bg-grey text-white">Invoicing</h6>
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-group col-md-4">
                                    <FormInputText
                                        label="Invoice Recipient"
                                        name="invoice_recipient"
                                        type="text"
                                        classes={errors.invoice_recipient ? 'form-control is-invalid' : 'form-control'}
                                        value={invoice_recipient}
                                        handleChange={this.handleInputChange}
                                        error={errors.invoice_recipient}
                                    />
                                </div>
                                <div className="form-group col-md-4">
                                    <FormInputText
                                        label="Bank Account Number"
                                        name="bank_account_number"
                                        type="text"
                                        classes={
                                            errors.bank_account_number ? 'form-control is-invalid' : 'form-control'
                                        }
                                        value={bank_account_number}
                                        handleChange={this.handleInputChange}
                                        error={errors.bank_account_number}
                                    />
                                </div>
                                <div className="form-group col-md-4">
                                    <FormInputText
                                        label="Bank Sort Code"
                                        name="bank_sort_code"
                                        type="text"
                                        classes={errors.bank_sort_code ? 'form-control is-invalid' : 'form-control'}
                                        value={bank_sort_code}
                                        handleChange={this.handleInputChange}
                                        error={errors.bank_sort_code}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-group col-md-4">
                                    <FormInputText
                                        label="VAT Number"
                                        name="vat_number"
                                        type="text"
                                        classes={errors.vat_number ? 'form-control is-invalid' : 'form-control'}
                                        value={vat_number}
                                        handleChange={this.handleInputChange}
                                        error={errors.vat_number}
                                    />
                                </div>
                                {this.props.userIsAdmin ? (
                                    <Fragment>
                                        <div className="form-group col-md-4">
                                            <FormInputNumber
                                                type="number"
                                                label="Payment Term"
                                                name="payment_term"
                                                step="1"
                                                min="1"
                                                classes={
                                                    errors.payment_term ? 'form-control is-invalid' : 'form-control'
                                                }
                                                value={payment_term}
                                                handleChange={this.handleInputChange}
                                                error={errors.payment_term}
                                            />
                                        </div>
                                        <div className="form-group col-md-4">
                                            <FormSelect
                                                label="Auto-generate Invoice Period"
                                                name="invoice_period"
                                                classes={
                                                    errors.invoice_period ? 'form-control is-invalid' : 'form-control'
                                                }
                                                value={invoice_period}
                                                handleChange={this.handleInputChange}
                                                options={['weekly', 'fortnightly', 'monthly']}
                                                error={errors.invoice_period}
                                            />
                                        </div>
                                    </Fragment>
                                ) : (
                                    ''
                                )}
                            </div>
                            {Number(this.props.mainSpId) !== this.props.provider.id && this.props.userIsAdmin ? (
                                <div className="row">
                                    <div className="form-group col-md-12">
                                        <FormCheckbox
                                            label="SELF-BILLING"
                                            name="self_billing"
                                            checked={self_billing}
                                            handleChange={this.handleInputChange}
                                        />
                                        <FormCheckbox
                                            label="VAT REGISTERED"
                                            name="vat_registered"
                                            checked={vat_registered || false}
                                            handleChange={this.handleInputChange}
                                        />
                                        <FormCheckbox
                                            label="ACTIVE INVOICE"
                                            name="active_invoice"
                                            checked={active_invoice || false}
                                            handleChange={this.handleInputChange}
                                        />
                                        <FormCheckbox
                                            label="REVIEW INVOICES"
                                            name="review_invoices"
                                            checked={review_invoices || false}
                                            handleChange={this.handleInputChange}
                                        />
                                        {this.props.userIsReviewer && (
                                            <FormCheckbox
                                                label="MANAGER REVIEW JOBS"
                                                name="manager_review_jobs"
                                                checked={manager_review_jobs || false}
                                                handleChange={this.handleInputChange}
                                            />
                                        )}
                                        {this.props.userIsSuperadmin && (
                                            <FormCheckbox
                                                label="SUPERADMIN REVIEW JOBS"
                                                name="superadmin_review_jobs"
                                                checked={superadmin_review_jobs || false}
                                                handleChange={this.handleInputChange}
                                            />
                                        )}
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                        </Fragment>
                    )}
                    <div className="row pt-3">
                        <div className="col-12">
                            <SubmitButton
                                buttonText={submitButtonText}
                                loading={this.state.loading}
                                style={{ width: 230, marginTop: 50 }}
                            />
                        </div>
                    </div>
                </form>
            </Fragment>
        );
    }
}

if (document.getElementById('createProvider')) {
    let element = document.getElementById('createProvider');

    ReactDOM.render(
        <CreateServiceProvider
            postcodes={JSON.parse(element.dataset.postcodes)}
            provider={JSON.parse(element.dataset.provider)}
            edit={element.dataset.edit}
            coverage={element.dataset.coverage}
            mainSpId={element.dataset.main_sp_id}
            userIsAdmin={element.dataset.user_is_admin}
            userIsReviewer={element.dataset.user_is_reviewer}
            userIsSuperadmin={element.dataset.user_is_superadmin}
            canUpdatePricing={element.dataset.can_update_pricing}
        />,
        element
    );
}

export default CreateServiceProvider;
